export default __webpack_public_path__ + "static/media/before.b4bcb053.png";